import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import useResponsiveFontSize, { IuseResponsiveFontSizeProps } from './use-responsive-font-size';
export const ResponsiveFontSize: React.FC<WithChildrenCommonProps<IuseResponsiveFontSizeProps>> = t0 => {
  const $ = _c(4);
  const {
    children,
    ratio,
    optionsObject
  } = t0;
  const ref = useResponsiveFontSize(ratio, optionsObject);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      height: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== ref) {
    t2 = <div ref={ref} style={t1}>{children}</div>;
    $[1] = children;
    $[2] = ref;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};